import homeQuickAccessSlider from "./homeQuickAccess";
import latestNewsSlider from './latestNews';
import equipePedagoSlider from "./equipePedago";

export default class Blocks {
  init() {
    this.initHomeQuickAccess();
    this.initHomeLatestNews();
    this.initEquipePedago();
  }

  initHomeQuickAccess() {
    homeQuickAccessSlider();
  }

  initHomeLatestNews() {
    latestNewsSlider();
  }

  initEquipePedago() {
    equipePedagoSlider();
  }
}